import React from 'react';
import { ChakraV3 } from '..';

interface Props extends ChakraV3.ImageProps {}

export const FadeImage = (props: Props) => {
  const [isLoaded, setLoaded] = React.useState(false);

  return (
    <ChakraV3.Image
      onLoad={() => setLoaded(true)}
      opacity={isLoaded ? 1 : 0}
      transition='opacity 0.5s ease-in-out'
      {...props}
    />
  );
};
